import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { AuthService } from 'app/auth/auth.service';
import { DashboardService } from 'app/dashboard/dashboard.service';
import { OpdVisitService } from 'app/opdvisits/Services/OpdVisit.service';
import { BillingserviceService } from '../billingService.service';

import { BillSearchList } from '../Models/billing.Models';
import { SelectionModel } from '@angular/cdk/collections';
import * as moment from 'moment';
import { FormControl } from '@angular/forms';
import { map, startWith, takeUntil } from 'rxjs/operators';
import { Observable, Subject } from 'rxjs';

@Component({
  selector: 'app-billing-search',
  templateUrl: './billing-search.component.html',
  styleUrls: ['./billing-search.component.scss']
})
export class BillingSearchComponent implements OnInit {
  destroySearchBill$: Subject<boolean> = new Subject<boolean>();
  catselected = -1;
  selectId: any;
  BillListArray: any = [];
  maxDate;
  startdate: any;
  enddate: any;

  formDate: any;
  toDate: any
  private filteredaddbillBranchArray: Observable<any[]>;
  branchId: FormControl;
  brnachid:any
  branchname:any
  checkType:any

  todaysdate = this.authService.getServerDate;
  displayedColumns: string[] = ['billDate', 'pK_BillId', 'billNo', 'branchCode', 'displayFinYear', 'partyName', 'doctor', 'billSerieseCode', 'fK_RegId',
    'firstName', 'mobileNo', 'netBillAmt', 'serviceChargeAmt', 'discountAmt', 'totalAmt'];
  dataSource = new MatTableDataSource<BillSearchList>();
  selection = new SelectionModel<BillSearchList>(true, []);
  // surgerydepartments_ds = new MatTableDataSource<SurgeryDepartmentModel>();
  // surgerycategories_ds = new MatTableDataSource<CategoriesModel>();
  getBranceId: any;
  searchType: string = 'fK_RegId';
  searchParaValue: string = '';
  // dataSource=new MatTableDataSource();
  // displayedColumns_surgerydepartments: string[] = ['surgeryDeptName'];
  // displayedColumns_surgerycategories: string[] = ['surgeryCatName'];
  constructor(public dialog: MatDialog, public dashboardService: DashboardService, public datepipe: DatePipe,
    public authService: AuthService, private datePipe: DatePipe,
    public opdvisitService: OpdVisitService, private billingservice: BillingserviceService) { }


  // Track scrolling and update paginator


  ngOnInit(): void {
    this.branchId = new FormControl();
    this.searchType = 'fK_RegId'
    this.brnachid = this.authService.Loggeduser.branchid;
    // this.startdate= this.datePipe.transform(this.authService.getServerDate, "yyyy-MM-dd");
    // this.enddate = this.datePipe.transform(this.authService.getServerDate, "yyyy-MM-dd");
    this.formDate = this.datePipe.transform(this.authService.getServerDate, "yyyy-MM-dd");
    this.toDate = this.datePipe.transform(this.authService.getServerDate, "yyyy-MM-dd");

    
    // this.getbills(this.startdate,this.enddate);
    this.maxDate = moment(this.authService.getServerDate).format('YYYY-MM-DD');
    this.billingservice.billingSticker = null;
    this.getBranchList();
  }

  getStartdate(): string {
    return this.startdate;
  }


  onSearchTypeChange(event: any) {
    this.searchType = event.value;
  }
  getBillFilterRes() {
   let payload :any
    if(this.checkType == 1){
       payload = {
        "Fromdate": this.formDate,
        "Todate": this.toDate,
        "BranchID":this.authService.Loggeduser.usertypeid == 9 ? 0 : this.brnachid,
        "SpecialityIdModule": this.authService.Loggeduser.specialityId,
        "Searchtype": 'S',
        "SearchPara": this.searchType,
        "SearchParaValue": this.searchParaValue
      }
    }else if(this.checkType == 2 ){
       payload = {
        "Fromdate": this.formDate,
        "Todate": this.toDate,
        "BranchID": this.brnachid,
        "SpecialityIdModule": this.authService.Loggeduser.specialityId,
        // "Searchtype": 'S',
        // "SearchPara": this.searchType,
        // "SearchParaValue": this.searchParaValue
      }
    }
    
    this.billingservice.getBillFilter(payload).pipe(takeUntil(this.destroySearchBill$)).subscribe((res) => {
      if (res.length>0) {
        this.dataSource.data = res;
      } else {
        this.dashboardService.openSnackBar("Record Not Found", "OK");
      }
    }, err => {
      if (err.status == 403) {
        this.dashboardService.openSnackBar("You Don't have Permission", "OK");
      } else if (err.error.statusCode == 422) {
        this.dashboardService.openSnackBar(err.error.message, "OK");
      } else {
        this.dashboardService.openSnackBar("API Failed", "OK");
      }
    })
  }

  showBillrecord(type) {
  this.checkType = type
    // if (this.formDate > this.maxDate || this.toDate > this.maxDate) {
    //   this.dashboardService.openSnackBar("Select the Present or past date", "OK");
    // } else
     if (this.formDate > this.toDate) {
      this.dashboardService.openSnackBar("From Date should be less then To Date", "OK");
    } else {
      this.getBillFilterRes();
    }
    this.closeadvanceSearch();
  }

  closedialog() {
    this.dialog.closeAll();
  }


  branchList: any
  getBranchList() {
    this.billingservice.getBrachMaster().subscribe(data => {
      this.branchList = data;
      this.branchControllbill();
    });
  }

  branchControllbill() {
    this.branchId = new FormControl();
    this.filteredaddbillBranchArray = this.branchId.valueChanges
      .pipe(
        startWith(''),
        map(country => country ? this.filterBranchbillfunction(country) : this.branchList.slice())
      );
  }

  filterBranchbillfunction(name: string) {
    return this.branchList.filter(item =>
      item.branchName.toLowerCase().indexOf(name.toLowerCase()) === 0);
  }
  getbranchbillObj(e) {
    var val = e.option.id;
    this.branchname = e.option.value
    this.brnachid = val
  }

  applyFilter_grid(filterValue) {
    this.dataSource.filter = filterValue.trim().toLowerCase();

  }

  isAllSelected() {

    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }


  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {

    this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.data.forEach(row => this.selection.select(row));
  }

  selectRow(row) {
    this.selection.toggle(row);

    var data: any = [];
    data = this.selection.selected;
    this.billingservice.billingSticker = data;
    this.billingservice.lastbillid = data[0].pK_BillId
    this.dialog.closeAll();
  }

  openadvancesearch() {
    document.getElementById("advanceSearchFilterModal").style.display = "block";

  }

  closeadvanceSearch() {
    document.getElementById("advanceSearchFilterModal").style.display = "none";
  }

  ngOnDestroy(): void {
    this.destroySearchBill$.next(true);
    this.destroySearchBill$.unsubscribe();
    this.branchList = null;
    this.filteredaddbillBranchArray = null;
    this.branchname = null;
    this.brnachid = null;
  }
  // getbills(a,b){
  //   this.dashboardService.subscriptions=  this.billingservice.getallbills(a,b,this.getBranceId).subscribe(data=>this.allbillsuccsess(data),err=>this.allbillerrors(err))
  //  }

  // allbillsuccsess(data){
  //   this.BillListArray = data;
  //   this.dataSource.data = this.BillListArray.reverse();
  //    console.log('bill datasource', this.dataSource);
  //  console.log('all bill',data);
  // }
  //   allbillerrors(err){
  //    this.billingservice.lastbillid
  //  }

  //get rate list 
  // getServiceList(catid:any){
  //   this.billingservice.servicelist=[];
  //    let CategoryId=catid;
  //    let RateListId=this.billingservice.ratelist.rateListId;
  //    let RateTypeId=this.billingservice.billserviceConfig.fK_RatelistId;
  //    this.dashboardService.subscriptions= this.billingservice.get_service_list(CategoryId,RateListId,RateTypeId).subscribe((data: any[])=>{

  //     this.billingservice.servicelist = data;
  //     this.dataSource.data=this.billingservice.servicelist;
  //     console.log(this.billingservice.servicelist);
  //   })
  // }

  // filtersurgerylist(row){ 
  //   let catid = row.pkSurgeryCatId;
  //   this.catselected = catid;
  //   this.getServiceList(this.catselected);
  //    }

  // applyFilter_grid(filterValue){
  //   this.dataSource.filter = filterValue.trim().toLowerCase();

  // }

  // setbillgetdata(){
  //   let sdate = this.datePipe.transform(this.startdate, "yyyy-MM-dd");
  //   let edate = this.datePipe.transform(this.enddate, "yyyy-MM-dd");
  //   console.log(sdate,edate)
  //   if(sdate > this.maxDate || edate > this.maxDate){
  //     this.dashboardService.openSnackBar("Select the Present or past date", "OK");
  //   }else if(sdate > edate ){   
  //     this.dashboardService.openSnackBar("From Date should be less then To Date", "OK");
  //   }else{
  //      this.getbills(sdate,edate)
  //   }
  // }

  // addsurgery(){
  //   this.billingservice.selectedServiceRow=this.selection.selected;
  //   
  //  }
}
